import * as actions from '../actions/student.actions'

function initialState() {
  return {
    license: null,
    list: [],
    newStudent: null,
    step: null,
  }
}

const studentReducer = (state = initialState(), action) => {
  switch (action.type) {
  case actions.UPDATE_NEW_STUDENT:
    return {
      ...state,
      newStudent: {
        ...state.newStudent,
        ...action.userData,
      },
    }

  case actions.REMOVE_NEW_STUDENT:
    return {
      ...state,
      newStudent: null,
      step: null,
    }

  case actions.UPDATE_STUDENT_LIST:
    return {
      ...state,
      list: action.list,
    }

  case actions.ADD_STUDENT_SET_STEP:
    return {
      ...state,
      step: action.step,
    }

  case actions.SET_LICENSE:
    return {
      ...state,
      license: {
        childBookId: action.license.childBookId,
        code: action.license.code,
      },
    }

  case actions.REMOVE_LICENSE:
    return {
      ...state,
      license: null,
    }

  default:
    return state
  }
}

export default studentReducer
